import { useState, useEffect } from "react";
import FETCH from "../../../../utils/fetch";

export default function useFetchIncome() {
  const [loading, setLoading] = useState(false);
  const [cachedData, setCachedData] = useState({});
  const [incomeList, setIncomeList] = useState([]);
  const [incomeNames, setIncomeNames] = useState([]); // New state for dropdown options
  const [totalPages, setTotalPages] = useState(1);
  const [dataReport, setDataReport] = useState(null);

  const getIncomeList = async (page) => {
    if (cachedData && cachedData[page]) {
      setLoading(false);
      updateStateWithData(cachedData[page]);
      return;
    }

    try {
      setLoading(true);
      const attributeToFetch = [
        "Date Income Starts",
        "Gross Monthly Wages",
        "Date Income Ends",
        "Income Name",
        "Passive or Active",
        "Frequency of Pay Periods",
        "Net Amount",
      ];
      const userRole =
      localStorage.getItem("role") != "undefined" &&
      JSON.parse(localStorage.getItem("role"));
    const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: userRole === "Financial Advisor Client"
            ? `?module=Income&page=${page}&limit=10&clientId=${ID}`
            : `?module=Income&page=${page}&limit=10`,
        body: { attributes: attributeToFetch },
      });

      if (datares && datares.records) {
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));

        // updateStateWithData(datares);
        // generateReportData(datares.records);
        processIncomeNames(datares.records);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // Process income names for dropdown options
  const processIncomeNames = (records) => {
    const names = records.map((income) => {
      const name = income["Income Name"] || "Unnamed Income";

      return {
        value: income.id || Math.random().toString(36).substr(2, 9),
        label: name.trim(),
        ...income,
      };
    });

    setIncomeNames(names);
  };

  const updateStateWithData = (datares) => {
    if (datares && datares.records) {
      setIncomeList(datares.records);
    }
    if (datares && datares.pagination) {
      setTotalPages(
        Math.ceil(datares.pagination.total / datares.pagination.limit)
      );
    }
  };
  // Log attributes and disasterAttribute whenever they change
  useEffect(() => {
    getIncomeList(1);
  }, []);

  return {
    loading,
    incomeList,
    incomeNames,
    totalPages,
    dataReport,
    getIncomeList,
  };
}
